import { myFetch, HttpMethod } from './baseService';

// ==================== INTERFACES ====================

export interface InsertarZonaComunRequest {
  unidad_residencial_codigo: string;
  nombre_zona_comun: string;
  descripcion_zona_comun: string;
  valor_alquiler: number;
  dia_mantenimiento_codigo: string;
}

export interface ZonaComun {
  zco_codigo: string;
  zco_ruta_foto_principal: string;
  zco_unidad_residencial: string;
  zco_unidad_residencial_nombre: string;
  zco_nombre: string;
  zco_descripcion: string;
  zco_valor_alquiler: number;
  zco_estatus: string;
  zco_estatus_nombre: string;
  zco_dia_mantenimiento: string;
  zco_dia_mantenimiento_nombre: string;
}

export interface ObtenerZonasComunesRequest {
  unidad_residencial_codigo: string;
  zona_comun_codigo: string;
}

export interface FotoZonaComun {
  fzc_codigo: number;
  fzc_zona_comun: string;
  fzc_zona_comun_nombre: string;
  fzc_ruta_foto: string;
  fzc_principal: number;
  fzc_activa: number;
}

export interface ObtenerFotosZonaComunRequest {
  "zona comun codigo": string;
}

export interface EliminarFotoZonaComunRequest {
  codigo: number;
  "zona comun codigo": string;
}

export interface MarcarFotoPrincipalRequest {
  codigo: number;
  "zona comun codigo": string;
}

export interface EstatusZonaComun {
  ezc_codigo: string;
  ezc_nombre: string;
}

export interface ModificarZonaComunRequest {
  zona_comun_codigo: string;
  nombre_zona_comun: string;
  descripcion_zona_comun: string;
  valor_alquiler: number;
  dia_mantenimiento_codigo: string;
  estatus_codigo: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// ==================== FUNCIONES API ====================

/**
 * Insertar una nueva zona común
 */
export const insertarZonaComun = async (
  payload: InsertarZonaComunRequest
): Promise<ApiEnvelope<ZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ZonaComun[]>>(
    'zona_comun/Insertar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Insertar archivos (fotos) de zona común
 */
export const insertarFotosZonaComun = async (
  zonaComunCodigo: string,
  fotos: File[]
): Promise<ApiEnvelope<any>> => {
  const formData = new FormData();
  formData.append('fzc_zona_comun', zonaComunCodigo);
  
  // Agregar cada foto al FormData
  fotos.forEach((foto) => {
    formData.append('fzc_fotos', foto);
  });

  const envelope = await myFetch<ApiEnvelope<any>>(
    'foto_zona_comun/InsertarArchivos',
    HttpMethod.POST,
    formData
  );
  return envelope;
};

/**
 * Obtener todas las zonas comunes
 */
export const obtenerZonasComunes = async (
  payload: ObtenerZonasComunesRequest
): Promise<ApiEnvelope<ZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ZonaComun[]>>(
    'zona_comun/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Obtener todas las fotos de una zona común
 */
export const obtenerFotosZonaComun = async (
  payload: ObtenerFotosZonaComunRequest
): Promise<ApiEnvelope<FotoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<FotoZonaComun[]>>(
    'foto_zona_comun/ObtenerTodo',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Eliminar una foto de zona común
 */
export const eliminarFotoZonaComun = async (
  payload: EliminarFotoZonaComunRequest
): Promise<ApiEnvelope<FotoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<FotoZonaComun[]>>(
    'foto_zona_comun/Eliminar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Marcar una foto como principal
 */
export const marcarFotoPrincipal = async (
  payload: MarcarFotoPrincipalRequest
): Promise<ApiEnvelope<FotoZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<FotoZonaComun[]>>(
    'foto_zona_comun/Marcar_como_principal',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Obtener todos los estatus de zona común
 */
export const obtenerEstatusZonaComun = async (): Promise<ApiEnvelope<EstatusZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<EstatusZonaComun[]>>(
    'estatus_zona_comun/ObtenerTodos',
    HttpMethod.POST,
    {}
  );
  return envelope;
};

/**
 * Modificar una zona común
 */
export const modificarZonaComun = async (
  payload: ModificarZonaComunRequest
): Promise<ApiEnvelope<ZonaComun[]>> => {
  const envelope = await myFetch<ApiEnvelope<ZonaComun[]>>(
    'zona_comun/Modificar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

